import _ from 'lodash';

import Table from './Table';

class DataTable {
    constructor (data, options) {
        this.options = options;
        this._tables = [];
        if (data) {
            this._createDataTable(data);
        }
    }

    convertToTable (table = -1) {
        let output = [];

        if (table >= 0) {
            const values = this.getRows(null, table);
            values.splice(0, 0, this.getHeader(table));
            output.push(values);
        } else {
            let isEqual = true;

            _.forEach(_.range(0, this._tables), i => {
                if (!this._tables[i].isEqual(this._tables[i + 1])) {
                    isEqual = false;
                }
            });

            if (isEqual) {
                output.push(this.getHeader());
                _.forEach(this._tables, (t, i) => {
                    return _.forEach(this.getRows(null, i), row => output.push(row));
                });
            } else {
                _.forEach(this._tables, (t, i) => {
                    const values = this.getRows(null, i);
                    values.splice(0, 0, this.getHeader(i));
                    if (this.total() <= 1) { output = values; } else { output.push(values); }
                });
            }
        }

        return output;
    }

    setOptions (options) {
        this.options = _.assign({}, this.options, options);
    }

    getAll () {
        return this._tables;
    }

    get (id) {
        return this._tables[id];
    }

    add (data) {
        return this._createDataTable(data);
    }

    remove (id) {
        return this._tables.splice(id, 1);
    }

    total () {
        return this._tables.length;
    }

    setHeader (header) {
        this._tables.customHeader = header;
    }

    getHeader (table = 0) {
        let columns;
        const header = _.isArray(this.options.column) ? [this.options.row] : [this.options.column];

        if (this._tables.customHeader) {
            columns = this._tables.customHeader;
        } else if (table === 'all') {
            columns = [];
            _.forEach(this._tables, t => {
                return _.forEach(t.columns, col => {
                    if (this.options.limit && t.columns.length > this.options.limit) {
                        if (!columns.contains(col && columns.length <= this.options.limit)) {
                            return columns.push(col);
                        }
                    } else {
                        if (!columns.contains(col)) {
                            return columns.push(col);
                        }
                    }
                });
            });
        } else if (this.options.limit && this._tables[table].columns.length > this.options.limit) {
            columns = this._tables[table].columns.filter((column, total) => total < this.options.limit);
        } else {
            columns = this._tables[table].columns;
        }

        return header.concat(columns);
    }

    getRows (line = 0, table = 0, limit) {
        let output = [];
        _.forEach(this._tables[table].rows, (name, i) => {
            let limit = 0;
            const values = [name];
            _.forEach(this._tables[table].body, row => {
                if (this.options.limit && ++limit > this.options.limit) {
                    return;
                }

                return values.push(row[name]);
            });

            if (line === i + 1) {
                output = values;
                return false;
            }

            return output.push(values);
        });

        return limit ? _.take(output, limit + 1) : output;
    }

    getTotalRows (table = 0) {
        if (this.options.limit && this._tables[table].rows.length > this.options.limit) {
            return this.options.limit;
        }

        return this._tables[table].rows.length;
    }

    getTotalColumns (table = 0) {
        if (this.options.limit && this._tables[table].columns.length > this.options.limit) {
            return this.options.limit;
        }

        return this._tables[table].columns.length;
    }

    _createDataTable (data) {
        if (this.options.sort) {
            data.orderBy(this.options.sort);
        }

        return this._tables.push(new Table(data, this.options));
    }
}

export default DataTable;



// WEBPACK FOOTER //
// ./src/scripts/core/charts/Datatable.js